import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CalendarHeart, MessageCircle, CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES, WHATSAPP_BASE } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", phone: "", service: "", preferred_date: "", note: "" };
const field = "w-full rounded-2xl border border-pink-200/70 bg-white/80 px-5 py-3.5 text-sm text-[#1a1118] placeholder:text-zinc-400 outline-none transition-[border-color,box-shadow] duration-300 focus:border-[#e6007e] focus:shadow-[0_0_0_4px_rgba(230,0,126,0.12)]";

const buildMessage = (f) => {
  const date = f.preferred_date ? new Date(f.preferred_date).toLocaleDateString("tr-TR") : "Belirtilmedi";
  return `Merhaba Diva Nail Beauty 👋\n\nRandevu talebim:\n• Ad Soyad: ${f.name}\n• Telefon: ${f.phone}\n• Hizmet: ${f.service}\n• Tercih Edilen Tarih: ${date}${f.note ? `\n• Not: ${f.note}` : ""}\n\nUygun saatler için dönüş yapabilir misiniz?`;
};

export const Appointment = () => {
  const [form, setForm] = useState(EMPTY);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.service) return toast.error("Lütfen bir hizmet seçin.");
    const url = `${WHATSAPP_BASE}?text=${encodeURIComponent(buildMessage(form))}`;
    window.open(url, "_blank", "noopener,noreferrer");
    axios.post(`${API}/appointments`, { ...form, preferred_date: form.preferred_date || null, note: form.note || null }).catch(() => {});
    setDone(true);
    toast.success("WhatsApp'a yönlendiriliyorsunuz. Randevu talebiniz alındı!");
  };

  return (
    <div className="card-soft rounded-[2rem] p-7 sm:p-9 relative overflow-hidden" data-testid="appointment-form-card">
      <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-[radial-gradient(circle,rgba(230,0,126,0.15),transparent_60%)]" />
      <div className="relative">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-grad-pink text-white flex items-center justify-center"><CalendarHeart size={20} /></div>
          <div><h3 className="text-xl font-semibold text-[#1a1118]">Randevu Talebi</h3><p className="text-sm text-zinc-500">Formu doldurun, talebiniz WhatsApp üzerinden bize iletilsin.</p></div>
        </div>
        {done ? (
          <Reveal className="mt-10 text-center py-10" data-testid="appointment-success">
            <CheckCircle2 size={56} className="mx-auto text-[#e6007e]" />
            <p className="mt-4 text-lg font-semibold text-[#1a1118]">Talebiniz WhatsApp'a aktarıldı</p>
            <p className="mt-2 text-sm text-zinc-500">Teşekkürler {form.name.split(" ")[0]}, mesajı göndermeniz yeterli; en kısa sürede dönüş yapacağız.</p>
            <a href={`${WHATSAPP_BASE}?text=${encodeURIComponent(buildMessage(form))}`} target="_blank" rel="noopener noreferrer" data-testid="appointment-whatsapp-again" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#e6007e] hover:underline"><MessageCircle size={16} /> WhatsApp açılmadıysa buraya tıklayın</a>
            <div><button onClick={() => { setDone(false); setForm(EMPTY); }} data-testid="appointment-new-button" className="mt-4 text-xs text-zinc-400 hover:text-[#e6007e]">Yeni talep oluştur</button></div>
          </Reveal>
        ) : (
          <form onSubmit={submit} className="mt-8 grid sm:grid-cols-2 gap-4" data-testid="appointment-form">
            <input required minLength={2} value={form.name} onChange={set("name")} placeholder="Ad Soyad" className={field} data-testid="appointment-name-input" />
            <input required type="tel" minLength={10} value={form.phone} onChange={set("phone")} placeholder="Telefon (05xx xxx xx xx)" className={field} data-testid="appointment-phone-input" />
            <select required value={form.service} onChange={set("service")} className={`${field} ${!form.service ? "text-zinc-400" : ""}`} data-testid="appointment-service-select">
              <option value="" disabled>Hizmet Seçin</option>
              {SERVICES.map((s) => <option key={s.id} value={s.name}>{s.name}</option>)}
            </select>
            <input type="date" value={form.preferred_date} onChange={set("preferred_date")} className={field} data-testid="appointment-date-input" min={new Date().toISOString().slice(0, 10)} />
            <textarea rows={3} value={form.note} onChange={set("note")} placeholder="Not / Özel İstek (opsiyonel)" className={`${field} sm:col-span-2 resize-none`} data-testid="appointment-note-input" />
            <button type="submit" data-testid="appointment-submit-button" className="btn-grad-dark sm:col-span-2 inline-flex items-center justify-center gap-2 text-white font-semibold px-7 py-4 rounded-full">
              <MessageCircle size={18} /> WhatsApp'tan Randevu Talebi Gönder
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
